export default __webpack_public_path__ + "static/media/shareIcon-copy.a81a0d67.svg";